 import * as _ from 'lodash'

class ApplicationCommentDirective implements ng.IDirective {
        restrict = 'AE'
        controller = ApplicationCommentController
        controllerAs = 'acCtrl'
        bindToController = true
        templateUrl = 'controls/applicationComment/applicationComment.html'    
        scope = {
            applicationId: '='
        }               
}

class ApplicationCommentController {
    applicationId: number
    comments: any[];
    newComment: string
    public: boolean
    isOfficeUser: boolean
    pinnedComment: any;
    isCommentPinned: boolean = false;

    static $inject = ['$scope', 'ApplicationComments', 'Auth', 'dialogs'];
    constructor(private $scope, private ApplicationComments, private Auth, private dialogs) {

        this.isOfficeUser = Auth.user.isOfficer;

        $scope.$watch(() => this.applicationId, (newValue, oldValue) => {
            if (newValue) {
                this.refreshComments();
            }                
        });

        $scope.$on('applicationCommentsChange', (event, data) => {
            this.refreshComments();
        })
    }

    addComment() {  
        this.ApplicationComments.save({
            applicationId: this.applicationId,
            comment: this.newComment,
            author: this.Auth.user.firstName + ' ' + this.Auth.user.lastName,
            isPublic: this.public,
            pinned: this.isCommentPinned
        })
            .$promise
            .then(() => {
                this.newComment = "";
                return this.refreshComments().$promise;
            }, () => {
                this.dialogs.error('Internal error', 'Error occured while saving your comment. Please try again after a while.');
            });
    }

    refreshComments() {
        return this.ApplicationComments.query({
            applicationId: this.applicationId
        }, (result) => {
            this.pinnedComment = _.find(result, (x: any) => x.pinned);

            if(this.pinnedComment){
                _.remove(result, (x: any) => x.pinned);
            }

            this.comments = result;
        });
    }

    pinComment(commentId: number){
        return this.ApplicationComments.pinComment({
            applicationId: this.applicationId,
            commentId: commentId
        }, () => {
            this.refreshComments();
        });
    }

    unpinComment(commentId: number){
        return this.ApplicationComments.unpinComment({
            applicationId: this.applicationId,
            commentId: commentId
        }, () => {
            this.refreshComments();
        });
    }
}


angular
    .module('app')
    .directive('applicationComment', () => new ApplicationCommentDirective());